<template>
  <div class="ajout">
    <h2 class="bold">
      {{ $t($route.meta.title.replace(" - Ooftop", "").split(" - ")[1]) }}
    </h2>
    <div class="bg-blue">
      <div class="row">
        <div class="col-3">
          <p>
            <label>{{ $t("Identifiant") }}</label> :
            {{ user.infos_cli.username }}
          </p>
          <p>
            <label>{{ $t("Nom") }}</label> : {{ user.infos_cli.nom }}
          </p>
          <p>
            <label>{{ $t("Email") }}</label> : {{ user.infos_cli.email }}
          </p>
          <p>
            <label>{{ $t("Téléphone") }}</label> :
            {{ user.infos_cli.telephone }}
          </p>
        </div>
        <div class="col-3">
          <p>
            <label>{{ $t("Service") }}</label> : {{ user.infos_cli.service }}
          </p>
          <p>
            <label>{{ $t("Organisation") }}</label> :
            {{ user.infos_cli.organisation }}
          </p>
        </div>
        <div class="col-3">
          <b-btn
            class="btn-gold"
            @click="showPasswordModif = true"
            v-if="showPasswordModif == false"
            >{{ $t("Modifier mon mot de passe") }}</b-btn
          >
          <b-form
            class="d-block forms"
            v-if="showPasswordModif"
            @submit.prevent="handleSubmit"
          >
            <b-form-group
              id="passwordO-group"
              label="Ancien mot de passe"
              label-for="passwordO"
            >
              <b-form-input
                id="passwordO"
                v-model="datas.old_password"
                :type="viewPasswordOld ? 'text' : 'password'"
                required
                placeholder="Ancien mot de passe"
                :disabled="loading"
              ></b-form-input>
              <span
                class="material-icons"
                @click="viewPasswordOld = !viewPasswordOld"
                style="position:absolute;top:5px;right:5px;cursor:pointer"
                >visibility{{ viewPasswordOld ? "_off" : "" }}</span
              >
            </b-form-group>
            <b-form-group
              id="password-group"
              label="Mot de passe"
              label-for="password"
            >
              <b-form-input
                id="password"
                v-model="datas.password1"
                :type="viewPassword ? 'text' : 'password'"
                required
                placeholder="Mot de passe"
                :disabled="loading"
              ></b-form-input>
              <span
                class="material-icons"
                @click="viewPassword = !viewPassword"
                style="position:absolute;top:5px;right:5px;cursor:pointer"
                >visibility{{ viewPassword ? "_off" : "" }}</span
              >
              <small
                v-if="rules.uppercase"
                :class="
                  'passwordTest form-text text-muted ' +
                    (datas.password1 == '' || checkPass() ? '' : 'b')
                "
                >Le mot de passe doit contenir :
                <span class="text-black">
                  Le mot de passe ne doit pas contenir de mots évidents comme
                  votre nom, prénom, nom de votre entreprise, ou du site.
                </span>
                <span class="text-black">
                  Le mot de passe ne peut pas être un mot de passe déjà utilisé
                  par le passé.
                </span>
                <span
                  :class="
                    datas.password1.length >= rules.min_length
                      ? 'has_required'
                      : ''
                  "
                  >au moins {{ rules.min_length }} caractères</span
                >
                <span
                  :class="
                    datas.password1.length <= rules.max_length
                      ? 'has_required'
                      : ''
                  "
                  >au plus {{ rules.max_length }} caractères</span
                >
                <span
                  :class="
                    rules.uppercase.test(datas.password1) ? 'has_required' : ''
                  "
                  >au moins une majuscule</span
                >
                <span
                  :class="
                    rules.lowercase.test(datas.password1) ? 'has_required' : ''
                  "
                  >au moins une minuscule</span
                >
                <span
                  :class="
                    rules.number.test(datas.password1) ? 'has_required' : ''
                  "
                  >au moins un chiffre</span
                >
                <span
                  :class="
                    rules.special_chars.test(datas.password1)
                      ? 'has_required'
                      : ''
                  "
                  >au moins un caractère spécial</span
                >
              </small>
            </b-form-group>
            <b-form-group
              id="password2-group"
              label="Confirmation"
              label-for="password2"
            >
              <b-form-input
                id="password2"
                v-model="datas.password2"
                :type="viewPassword2 ? 'text' : 'password'"
                required
                placeholder="Mot de passe"
                :disabled="loading"
              ></b-form-input>
              <span
                class="material-icons"
                @click="viewPassword2 = !viewPassword2"
                style="position:absolute;top:5px;right:5px;cursor:pointer"
                >visibility{{ viewPassword2 ? "_off" : "" }}</span
              >
              <small
                v-if="rules.uppercase"
                :class="
                  'passwordTest form-text text-muted ' +
                    (datas.password2 == '' || checkPass() ? '' : 'b')
                "
              >
                <span
                  :class="
                    datas.password1 == datas.password2 ? 'has_required' : ''
                  "
                  >les mots de passe doivent être identiques</span
                >
              </small>
            </b-form-group>
            <b-btn class="btn-gold" type="submit">{{
              $t("Modifier mon mot de passe")
            }}</b-btn>
          </b-form>
        </div>
      </div>
    </div>
    <div class="pt-5">
      <a href="javascript:void(0)" @click="$bvModal.show('modal-cgu')">
        {{ $t("Conditions Générales de Vente") }}</a
      ><br />
      <a href="javascript:void(0)" @click="$bvModal.show('modal-cookies')">
        {{ $t("Politique de cookies") }}</a
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DynField from "@/components/Fields/DynField";
export default {
  components: { DynField },
  data() {
    return {
      user: {},
      viewPasswordOld: false,
      viewPassword: false,
      viewPassword2: false,
      showPasswordModif: false,
      datas: {
        username: "",
        token: "",
        old_password: "",
        password1: "",
        password2: "",
      },
      rules: {
        min_length: 8,
        max_length: 16,
        special_chars: /[\@\[\]^?_!"#$%&'()*+,\-./:;{}<>=|~]/,
        lowercase: /[a-z]/,
        uppercase: /[A-Z]/,
        number: /[0-9]/,
      },
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.datas.username = this.user.infos_cli.username;
    this.datas.token = this.user.authdata;
    var p = this;
    axios.get(this.$apiUrl + "user/getPassRules").then(function(response) {
      p.rules.min_length = response.data.min_length;
      p.rules.max_length = response.data.max_length;
      p.rules.special_chars = new RegExp(response.data.special_chars);
      p.rules.lowercase = new RegExp(response.data.lowercase);
      p.rules.uppercase = new RegExp(response.data.uppercase);
      p.rules.number = new RegExp(response.data.number);
    });
  },
  mounted() {},
  methods: {
    checkPass() {
      return (
        this.datas.password1.length >= this.rules.min_length &&
        this.datas.password1.length <= this.rules.max_length &&
        this.rules.uppercase.test(this.datas.password1) &&
        this.rules.lowercase.test(this.datas.password1) &&
        this.rules.number.test(this.datas.password1) &&
        this.rules.special_chars.test(this.datas.password1) &&
        this.datas.password2 == this.datas.password1
      );
    },
    handleSubmit(e) {
      var p = this;
      if (this.checkPass()) {
        if (p.loading) return false;
        p.loading = true;
        let formData = new FormData();
        formData.append("datas", JSON.stringify(p.datas));
        formData.append("host", window.location.hostname);
        this.connexion = true;
        axios
          .post(
            this.$apiUrl +
              "user/passAction/change?lang=" +
              this.$i18n.locale +
              "&auth=" +
              JSON.stringify(p.auth_header()),
            formData,
            {
              headers: {
                "Content-Type":
                  "multipart/form-data; charset=utf-8; boundary=" +
                  Math.random()
                    .toString()
                    .substr(2),
              },
            }
          )
          .then(function(response) {
            if (response.data.error) {
              p.show_alert("warning", response.data.error.join("<br/>"));
            } else {
              p.show_alert("success", "Mot de passe modifié.");
              p.showPasswordModif = false;
              p.datas.password1 = "";
              p.datas.password2 = "";
              p.datas.old_password = "";
            }
            p.connexion = false;
            p.loading = false;
          })
          .catch(function(error) {
            p.show_alert(
              "warning",
              "Le service api-fw.ooftop.fr n'est pas accessible."
            );
            p.connexion = false;
            p.loading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.passwordTest {
  display: none;
}
.passwordTest.b {
  display: block;
}
.passwordTest > span {
  display: block;
}
.passwordTest.b > span {
  color: red;
}
.passwordTest.b > span.has_required {
  color: green;
}
.passwordTest.b > span.text-black {
  color: black;
}
</style>
